import n from "qs";
const a = (t) => ({ coordinate: e, queryParams: { types: o, ...s } }) => t.get(
  `/geocoding/v5/mapbox.places/${e.lng},${e.lat}.json?${n.stringify({
    ...s,
    types: o ? o.join(",") : void 0
  })}`
);
export {
  a as getReverseGeocode
};
//# sourceMappingURL=index.es491.js.map
